<template>
  <div class="p-6 bg-white/60 rounded-xl min-h-screen">
    <div class="flex justify-between items-center mb-6">
      <h5 class="text-l font-bold text-gray-800 inline-block transition-all duration-500">
        <span
            class="bg-clip-text text-transparent bg-gradient-to-r from-purple-500 via-pink-500 to-blue-500 hover:animate-pulse ml-2">
           انتقال به پردازش از انبار
        </span>
      </h5>
      <div class="flex gap-3 mr-3">
        <div class="flex items-center gap-1">
          <store-select label="انبار" v-model="filters.store" @input="fetchProducts"></store-select>
          <span class="rounded-xl p-2 bg-blue-700 text-white text-xs" v-if="filters.product">
            <v-icon @click="resetFilters" class="cursor-pointer ml-3 mr-1" color="white">fa-times</v-icon>
            شناسه محصول : {{filters.product}}
          </span>

        </div>

      </div>
    </div>
    <div
        class="bg-white bg-opacity-70 backdrop-filter backdrop-blur-lg rounded-xl p-3 mb-6 shadow-sm border border-gray-100">
      <div class="flex flex-wrap items-center gap-2">
        <!-- Search -->
        <div class="relative w-32">
          <input
              v-model="filters.name_search"
              placeholder="نام"
              class="px-2 py-1.5 bg-gray-100 text-xs rounded-lg border w-full text-right"
              @keyup.enter="applyFilters"
          >
        </div>
        <div class="relative w-32">
          <input
              v-model="filters.sku"
              placeholder="SKU"
              class="px-2 py-1.5 bg-gray-100 text-xs rounded-lg border w-full text-right"
              @keyup.enter="applyFilters"
          >
        </div>
        <div class="relative w-32">
          <input
              v-model="filters.id_in"
              placeholder="شناسه"
              class="px-2 py-1.5 bg-gray-100 text-xs rounded-lg border w-full text-right"
              @keyup.enter="applyFilters"
          >
        </div>
        <div class="relative w-32">
          <select
              @change="applyFilters"
              v-model="filters.brand_in"
              class="px-2 py-1.5 bg-gray-100 text-xs rounded-lg border w-32 text-right"
          >
            <option value="">همه برندها</option>
            <option
                v-for="brand in brands"
                :key="brand.id"
                :value="brand.id"
            >
              {{ brand.name }}
            </option>
          </select>
        </div>
        <div class="flex gap-1">
          <button
              @click="resetFilters"
              class="p-1.5 bg-gradient-to-r from-gray-500 to-blue-600 text-white rounded-full shadow-sm hover:shadow-md transition-all duration-300 transform hover:scale-105"
              title="حذف فیلترها"
          >
            <svg xmlns="http://www.w3.org/2000/svg" class="h-4 w-4" fill="none" viewBox="0 0 24 24"
                 stroke="currentColor">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                    d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16"/>
            </svg>
          </button>

          <button
              @click="applyFilters"
              class="p-1.5 bg-gradient-to-r from-red-500 to-blue-600 text-white rounded-full shadow-sm hover:shadow-md transition-all duration-300 transform hover:scale-105"
              title="اعمال فیلتر"
          >
            <svg xmlns="http://www.w3.org/2000/svg" class="h-4 w-4" fill="none" viewBox="0 0 24 24"
                 stroke="currentColor">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                    d="M3 4a1 1 0 011-1h16a1 1 0 011 1v2.586a1 1 0 01-.293.707l-6.414 6.414a1 1 0 00-.293.707V17l-4 4v-6.586a1 1 0 00-.293-.707L3.293 7.293A1 1 0 013 6.586V4z"/>
            </svg>
          </button>
        </div>
      </div>
    </div>

    <!-- Table -->
    <div
        class="bg-white bg-opacity-70 backdrop-filter backdrop-blur-lg rounded-xl shadow-sm border border-gray-100 overflow-hidden">
      <div class="overflow-x-auto">
        <table class="min-w-full text-sm">
          <thead class="bg-gray-50 bg-opacity-70">
          <tr>
            <th class="p-3 items-center text-center text-[6px] text-gray-500">SKU</th>
            <th class="p-3 text-[6px] text-gray-500">محصول</th>
            <th class="p-3 items-center text-center text-[6px] text-gray-500">تعداد انتقال</th>
            <th class="p-3 items-center text-center text-[6px] text-gray-500"></th>
          </tr>
          </thead>
          <tbody>
          <tr v-if="loading">
            <td colspan="6" class="p-4 text-center">
              <div class="flex justify-center items-center gap-2">
                <svg class="animate-spin h-5 w-5 text-blue-500" xmlns="http://www.w3.org/2000/svg" fill="none"
                     viewBox="0 0 24 24">
                  <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
                  <path class="opacity-75" fill="currentColor"
                        d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                </svg>
                در حال بارگذاری...
              </div>
            </td>
          </tr>
          <tr v-else-if="products.length === 0">
            <td colspan="6" class="p-4 text-center text-gray-500">
              محصولی یافت نشد
            </td>
          </tr>
          <tr
              v-for="product in products"
              :key="product.id"
              class="border-t border-gray-100 hover:bg-gray-50 transition-colors duration-200"
          >
            <td class=" items-center text-center p-3 font-medium text-[9px] text-gray-900">
              {{ product.sixteen_digit_code || ' بدون کد' }}
            </td>
            <td class="p-3">
              <div class="flex items-center gap-3">
                <div class="relative" v-if="product.image">
                  <img
                      :src="img_source(product.image)"
                      class="w-10 h-10 rounded-lg object-cover border border-gray-200 shadow-sm"
                  >
                </div>
                <div>
                  <div class="text-[9px] font-medium text-gray-900">{{ product.name }}</div>
                  <div class="text-[9px] text-gray-500 text-xs mt-1 flex items-center gap-1"
                       v-if="product.variation_of">
                    <svg xmlns="http://www.w3.org/2000/svg" class="h-3 w-3" fill="none" viewBox="0 0 24 24"
                         stroke="currentColor">
                      <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                            d="M16 11V7a4 4 0 00-8 0v4M5 9h14l1 12H4L5 9z"/>
                    </svg>
                    {{ product.variation_of.name }}
                  </div>
                </div>
              </div>
            </td>
            <td class="items-center text-center p-3 text-[9px]">
              <input
                  type="number"
                  v-model="product.store_inventory"
                  class="text-center w-full py-2 rounded-md bg-green-100 border border-gray-300 focus:border-green-400 focus:ring-1 focus:ring-gray-200"
              />

            </td>
            <td class="items-center">
              <button v-if="product.store_inventory" @click="handleDone(product)"
                      class="p-2 bg-green-600 text-white text-[8px] rounded-lg"
                      title="انتقال">
                ثبت انتقال

              </button>
            </td>

          </tr>
          </tbody>
        </table>
      </div>

      <!-- Pagination -->
      <div class="p-4 border-t border-gray-100 flex flex-col md:flex-row justify-between items-center gap-4">
        <div class="text-sm text-gray-600">
          نمایش {{ (currentPage - 1) * itemsPerPage + 1 }} تا
          {{ Math.min(currentPage * itemsPerPage, totalProducts) }} از
          {{ totalProducts }} محصول
        </div>
        <div class="flex gap-1">
          <button
              @click="prevPage"
              :disabled="currentPage === 1"
              class="p-2 border border-gray-200 rounded-lg bg-white bg-opacity-50 hover:bg-gray-50 transition-colors duration-200 disabled:opacity-50 disabled:cursor-not-allowed"
              :class="{ 'opacity-50 cursor-not-allowed': currentPage === 1 }"
          >
            <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5" fill="none" viewBox="0 0 24 24"
                 stroke="currentColor">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 5l7 7-7 7"/>
            </svg>
          </button>
          <button
              v-for="page in visiblePages"
              :key="page"
              @click="goToPage(page)"
              class="p-2 text-center border border-gray-200 rounded-full transition-colors duration-200"
              :class="{
              'bg-gradient-to-r from-blue-500/60 to-blue-600/50 text-white shadow-md': page === currentPage,
              'bg-white bg-opacity-50 hover:bg-gray-50': page !== currentPage,
              'cursor-default': page === '...'
            }"
              :disabled="page === '...'"
          >
            {{ page }}
          </button>
          <button
              @click="nextPage"
              :disabled="currentPage * itemsPerPage >= totalProducts"
              class="p-2 border border-gray-200 rounded-lg bg-white bg-opacity-50 hover:bg-gray-50 transition-colors duration-200 disabled:opacity-50 disabled:cursor-not-allowed"
              :class="{ 'opacity-50 cursor-not-allowed': currentPage * itemsPerPage >= totalProducts }"
          >
            <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5" fill="none" viewBox="0 0 24 24"
                 stroke="currentColor">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 19l-7-7 7-7"/>
            </svg>
          </button>
        </div>
      </div>
    </div>
    <transition name="slide-fade">
      <div v-if="showNotification"
           class="fixed bottom-4 right-4 z-50 flex items-center p-4 w-[90%] max-w-xs text-gray-100 bg-gray-900 rounded-lg shadow-lg border border-gray-700">

        <div
            class="inline-flex items-center justify-center flex-shrink-0 w-8 h-8 rounded-lg text-green-400 bg-gray-800">
          <svg class="w-5 h-5" fill="currentColor" viewBox="0 0 20 20">
            <path fill-rule="evenodd"
                  d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
                  clip-rule="evenodd"/>
          </svg>
        </div>

        <div class="mr-3 text-sm font-normal pr-2">انتقال با موفقیت ثبت شد</div>

        <button @click="showNotification = false"
                class="mr-auto text-gray-400 hover:text-white rounded-lg p-1.5 hover:bg-gray-800">
          <svg class="w-5 h-5" fill="currentColor" viewBox="0 0 20 20">
            <path fill-rule="evenodd"
                  d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z"
                  clip-rule="evenodd"/>
          </svg>
        </button>
      </div>
    </transition>

  </div>
</template>

<script>
import PackingStoreHandle from "@/modules/store_handle/PackingStoreHandle";
import StoreSelect from "@/components/selects/StoreSelect";
import ProductsSelect from "@/components/selects/ProductSelect";

export default {
  name: 'InventoryTransfers',
  components: {ProductsSelect, StoreSelect, PackingStoreHandle},
  data() {
    return {
      showNotification: false,
      showQuickEdit: false,
      selectedProduct: null,
      selectedProductId: null,
      loading: true,
      products: [],
      totalProducts: 0,
      currentPage: 1,
      activePricing: [],
      itemsPerPage: 20,
      filters: {
        id_in: '',
        product: '',
        store: 1,
        min_inventory: '',
        name_search: '',
        sku: '',
        search_value: '',
        brand_in: '',
      },
      categories: [],
      brands: [],
      currencies: [],
      productSelected: null,
      showProductStoreHandle: false
    }
  },
  computed: {
    visiblePages() {
      const totalPages = Math.ceil(this.totalProducts / this.itemsPerPage)
      const range = 1
      const pages = []

      pages.push(1)

      if (this.currentPage - range > 2) {
        pages.push('...')
      }

      for (let i = Math.max(2, this.currentPage - range); i <= Math.min(totalPages - 1, this.currentPage + range); i++) {
        pages.push(i)
      }

      if (this.currentPage + range < totalPages - 1) {
        pages.push('...')
      }

      if (totalPages > 1) {
        pages.push(totalPages)
      }

      return pages
    },
  },
  methods: {
    isActive(product) {
      return this.activePricing.some(p => p === product);
    },
    showNotificationMessage() {
      this.showNotification = true;
      setTimeout(() => {
        this.showNotification = false;
      }, 5000);
    },
    fetchBrands() {
      this.request({
        url: this.endpoint('api/brands'),
        method: 'get',
        success: (data) => {
          this.brands = data
        }
      })
    },
    handleDone(product) {
      this.request({
        url: this.endpoint('store_handle/inventoryTransferCreate'),
        method: 'post',
        data: {
          from_store_id: this.filters.store,
          to_store_id: 1,
          quantity: product.store_inventory,
          product_id: product.product_id,
        },
        success: (data) => {
          this.showNotificationMessage()
          this.fetchProducts()
        },
      })
    },
    fetchProducts() {
      this.loading = true

      const params = {
        limit: this.itemsPerPage,
        offset: (this.currentPage - 1) * this.itemsPerPage,
        ...this.filters
      }

      Object.keys(params).forEach(key => {
        if (params[key] === '') {
          delete params[key]
        }
      })

      this.request({
        url: this.endpoint('store_handle/storeInventoryList'),
        method: 'get',
        params,
        success: (data) => {
          this.products = []
          for (let item of data.results) {
            this.products.push(
                {
                  product_id: item.product_id,
                  image: item.image,
                  product: item.id,
                  sixteen_digit_code: item.sixteen_digit_code,
                  name: item.name,
                  variation_of: item.variation_of,
                  product_type: item.product_type,
                  store_inventory: item.inventory,
                }
            )
          }
          this.totalProducts = data.count
          this.loading = false
        },
        error: () => {
          this.loading = false
        }
      })
    },

    applyFilters() {
      this.currentPage = 1
      this.fetchProducts()
    },

    resetFilters() {
      this.filters = {
        id_in: '',
        product: '',
        store: 5,
        min_inventory: '',
        name_search: '',
        sku: '',
        search_value: '',
        brand_in: '',
      }
      this.applyFilters()
    },

    refreshProducts() {
      this.fetchProducts()
    },

    prevPage() {
      if (this.currentPage > 1) {
        this.currentPage--
        this.fetchProducts()
      }
    },

    nextPage() {
      if (this.currentPage * this.itemsPerPage < this.totalProducts) {
        this.currentPage++
        this.fetchProducts()
      }
    },

    goToPage(page) {
      if (page !== '...') {
        this.currentPage = page
        this.fetchProducts()
      }
    },
    productStoreHandle(product) {
      this.selectedProduct = product
      this.showProductStoreHandle = true

    },
    active(product) {
      const index = this.activePricing.indexOf(product);
      if (index > -1) {
        this.activePricing.splice(index, 1);
      } else {
        this.activePricing.push(product);
      }
    },
    calculate_discount(price, discount) {
      return price - (price / 100 * discount)
    },
    closeProductStoreHandle() {
      this.selectedProduct = null
      this.showProductStoreHandle = false
    },


  },
  mounted() {
    if (this.$route.query.product) {
      this.filters.product = this.$route.query.product
    }
    if (this.$route.query.store_in) {
      this.filters.store = this.$route.query.store_in
    }
    this.fetchBrands()
    this.fetchProducts()
  }
}
</script>

<style>
/* RTL support */
body {
  direction: rtl;
  text-align: right;
}

/* Glass morphism effect */
.glass {
  background: rgba(255, 255, 255, 0.7);
  backdrop-filter: blur(10px);
  -webkit-backdrop-filter: blur(10px);
  border: 1px solid rgba(255, 255, 255, 0.18);
}

/* Neumorphism effect */
.neumorphism {
  border-radius: 16px;
  background: #f0f0f0;
  box-shadow: 8px 8px 16px #d9d9d9,
  -8px -8px 16px #ffffff;
}

/* Smooth transitions */
.transition-all {
  transition-property: all;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}

.truncate-text {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.glass-card {
  background: rgba(255, 255, 255, 0.12);
  backdrop-filter: blur(16px);
  -webkit-backdrop-filter: blur(16px);
  border: 1px solid rgba(255, 255, 255, 0.2);
}

.bg-secondary {
  background-color: #424242;
}


</style>